import { useState, useEffect } from 'react';
import { DEFAULT_FORM_DATA } from '../../../constants/projectsPage';

/**
 * Hook to manage page state for Projects page
 * @returns {Object} Page state and handlers
 */
export const useProjectsPageState = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [totalProjects, setTotalProjects] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [formData, setFormData] = useState(DEFAULT_FORM_DATA);
  const [projects, setProjects] = useState([]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    // Page will be reset automatically by useEffect when searchQuery changes
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData(DEFAULT_FORM_DATA);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Reset to page 0 when search query changes
  useEffect(() => {
    setPage(0);
  }, [searchQuery]);

  return {
    // State
    page,
    rowsPerPage,
    openDialog,
    loading,
    submitLoading,
    totalProjects,
    searchQuery,
    formData,
    projects,
    // Setters
    setPage,
    setRowsPerPage,
    setOpenDialog,
    setLoading,
    setSubmitLoading,
    setTotalProjects,
    setSearchQuery,
    setFormData,
    setProjects,
    // Handlers
    handleChangePage,
    handleChangeRowsPerPage,
    handleClearSearch,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
  };
};
